import { CardHeader, AccordionHeader } from "reactstrap";
import { convertTimestamp } from "../../../utils/convertTimestamp";
import { t } from "i18next";

const AccordionSessionHeader = ({ targetId, session }) => {
  const date = session?.createdAt;
  const isSubmitted = session?.status?.toLowerCase() === "submitted";

  return (
    <AccordionHeader targetId={targetId}>
      <CardHeader>
        {date && (
          <div className="d-flex align-items-center">
            <p className="text-muted text-truncate mb-0 handle-date-class">
              <span
                className="fw-semibold text-dark session-item-date"
                style={{ fontSize: "17px" }}
              >
                {convertTimestamp(date)}
              </span>
            </p>
            {isSubmitted && (
              <span className="header-awaiting-badge">
                {t("profile.awaitingAssessment")}
              </span>
            )}
          </div>
        )}
      </CardHeader>
    </AccordionHeader>
  );
};

export default AccordionSessionHeader;
